import { Box, Typography } from "@mui/material";
import ScreenRotation from "@mui/icons-material/ScreenRotation";
import { portraitOrientationMessageStyleProps } from "../theme/main";

export function PortraitOrientationMessage() {
  const {
    rootStyle,
    contentStyle,
    iconContainerStyle,
    iconStyle,
    titleStyle,
    bodyStyle,
  } = portraitOrientationMessageStyleProps;

  return (
    <Box
      component="main"
      sx={{
        ...rootStyle,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxSizing: "border-box",
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          ...contentStyle,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Box
          aria-hidden="true"
          sx={{
            ...iconContainerStyle,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            boxSizing: "border-box",
          }}
        >
          <ScreenRotation sx={iconStyle} />
        </Box>
        <Typography component="h1" sx={titleStyle}>
          Rotate your device
        </Typography>
        <Typography component="p" sx={bodyStyle}>
          This configurator is designed for landscape mode. Please rotate your
          device to continue.
        </Typography>
      </Box>
    </Box>
  );
}
